import React, { useState } from 'react';
import { CONFIRM_SOURCE, smsHref } from '../services/apptConfirm';

// Quick action on "Confirm appointment" tasks: edit the message, then Text opens the agent's texting app.
const btn = { background: '#111', color: '#D4AF37', border: '1px solid #D4AF37', borderRadius: 8, padding: '8px 14px', minHeight: 44, cursor: 'pointer', fontWeight: 600, textDecoration: 'none', display: 'inline-flex', alignItems: 'center' };

export default function PipelineConfirmQuickText({ task, onSent }) {
  const [open, setOpen] = useState(false);
  const [body, setBody] = useState(task?.smsBody || '');
  if (task?.source !== CONFIRM_SOURCE) return null;
  const href = smsHref(task.clientPhone, body);
  if (!href) return <p style={{ fontSize: 13, color: '#6b6b6b', margin: '8px 0 0' }}>No phone number on this pipeline entry, so there is no Text button.</p>;
  return (
    <div style={{ marginTop: 8 }}>
      {!open ? <button type="button" style={btn} onClick={() => setOpen(true)}>Text {task.clientName || 'client'}</button> : (
        <div>
          <textarea value={body} onChange={(e) => setBody(e.target.value)} rows={4} style={{ width: '100%', boxSizing: 'border-box', padding: 8, fontSize: 15 }} aria-label="Confirmation text" />
          <div style={{ display: 'flex', gap: 8, marginTop: 6 }}>
            <a href={href} style={btn} onClick={() => onSent && onSent()}>Send text</a>
            <button type="button" style={{ ...btn, background: '#fff', color: '#111' }} onClick={() => setOpen(false)}>Cancel</button>
          </div>
        </div>
      )}
    </div>
  );
}
